"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TranslationsStorage = void 0;
var LocalForage = require("localforage");
var sha1 = require("js-sha1");
var TranslationsStorage = function () {
  function TranslationsStorage(config) {
    this.storage = LocalForage.createInstance({
      name: config.name,
      storeName: 'translations'
    });
  }
  TranslationsStorage.prototype.setSpace = function (locale, space, keys) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.storage.ready()];
          case 1:
            _a.sent();
            return [4, this.storage.setItem(locale + "." + space, keys)];
          case 2:
            _a.sent();
            return [2];
        }
      });
    });
  };
  TranslationsStorage.prototype.getSpace = function (locale, space) {
    return __awaiter(this, void 0, void 0, function () {
      var keys;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.storage.ready()];
          case 1:
            _a.sent();
            return [4, this.storage.getItem(locale + "." + space)];
          case 2:
            keys = _a.sent();
            if (keys) {
              return [2, keys];
            }
            return [2, null];
        }
      });
    });
  };
  TranslationsStorage.prototype.getSpaces = function (locale) {
    var spaces = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      spaces[_i - 1] = arguments[_i];
    }
    return __awaiter(this, void 0, void 0, function () {
      var translations, promises;
      var _this = this;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            translations = {};
            promises = spaces.map(function (space) {
              return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  return [2, this.getSpace(locale, space).then(function (keys) {
                    if (keys !== null) {
                      translations[space] = keys;
                    }
                  })];
                });
              });
            });
            return [4, Promise.all(promises)];
          case 1:
            _a.sent();
            return [2, translations];
        }
      });
    });
  };
  TranslationsStorage.prototype.getEtag = function (locale) {
    var spaces = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      spaces[_i - 1] = arguments[_i];
    }
    return __awaiter(this, void 0, void 0, function () {
      var translations, flatTranslationPairs, sortedTranslationKeys, sortedTranslations;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4, this.getSpaces.apply(this, __spread([locale], spaces))];
          case 1:
            translations = _a.sent();
            flatTranslationPairs = Object.values(translations).reduce(function (prev, cur) {
              return __assign(__assign({}, prev), cur);
            }, {});
            sortedTranslationKeys = Object.keys(flatTranslationPairs).sort();
            sortedTranslations = sortedTranslationKeys.reduce(function (prev, cur) {
              prev[cur] = flatTranslationPairs[cur];
              return prev;
            }, {});
            return [2, sha1(JSON.stringify(sortedTranslations))];
        }
      });
    });
  };
  return TranslationsStorage;
}();
exports.TranslationsStorage = TranslationsStorage;